import { CameraIcon, CopyIcon, CrossCircledIcon } from '@radix-ui/react-icons';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonMenuBar } from 'components/common/menu-bar';

export const FeatureDemoMenubar = () => {
  return (
    <ErrorBoundary identifier="FeatureDemoMenubar">
      <CommonMenuBar
        menus={[
          {
            id: 'demo-file',
            trigger: 'File',
            items: [
              {
                id: 'file-option-1',
                label: 'Option 1',
                endSlot: <CopyIcon />,
                onClick: () =>
                  NotifyHelper.success({
                    message_md: 'You clicked on file option 1!',
                  }),
              },
              {
                id: 'file-option-2',
                label: 'Option 2',
                color: 'crimson',
                onClick: () =>
                  NotifyHelper.success({
                    message_md: 'You clicked on file option 2!',
                  }),
              },
            ],
          },
          {
            id: 'demo-edit',
            trigger: 'Edit',
            items: [
              {
                id: 'edit-option-1',
                label: 'Option 1',
                endSlot: <CopyIcon />,
                onClick: () =>
                  NotifyHelper.success({
                    message_md: 'You clicked on edit option 1!',
                  }),
              },
              {
                id: 'edit-option-2',
                label: 'Option 2',
                color: 'crimson',
                onClick: () =>
                  NotifyHelper.success({
                    message_md: 'You clicked on edit option 2!',
                  }),
              },
              {
                id: 'edit-option-3',
                label: 'Option 3',
                color: 'blue',
                startSlot: <CameraIcon />,
                onClick: () =>
                  NotifyHelper.success({
                    message_md: 'You clicked on edit option 3!',
                  }),
              },
            ],
          },
          {
            id: 'demo-click',
            trigger: 'Click',
            onClick: () => {
              NotifyHelper.success({ message_md: 'You clicked!' });
            },
          },
          {
            id: 'demo-disabled',
            trigger: <CrossCircledIcon />,
            disabled: true,
            items: [
              {
                id: 'file-option-1',
                label: 'Option 1',
                endSlot: <CopyIcon />,
                onClick: () =>
                  NotifyHelper.success({
                    message_md: 'You clicked on file option 1!',
                  }),
              },
              {
                id: 'file-option-2',
                label: 'Option 2',
                color: 'crimson',
                onClick: () =>
                  NotifyHelper.success({
                    message_md: 'You clicked on file option 2!',
                  }),
              },
            ],
          },
        ]}
      />
    </ErrorBoundary>
  );
};
